module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_8.3ce7ba3d.png";